import { Post, Article, Video } from '../types/content';
import { CATEGORIES } from '../types';
import { demoUsers } from './demoUsers';

// Helper function to get random items from an array
const getRandomItems = <T>(array: T[], count: number): T[] => {
  const shuffled = [...array].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count);
};

// Helper function to get a random user
const getRandomUser = () => demoUsers[Math.floor(Math.random() * demoUsers.length)];

export const demoPosts: Post[] = Array(20).fill(null).map((_, index) => {
  const author = getRandomUser();
  const category = CATEGORIES[Math.floor(Math.random() * CATEGORIES.length)];
  const subcategory = category.subcategories?.[Math.floor(Math.random() * (category.subcategories?.length || 1))];
  const tags = getRandomItems([
    'innovation', 'technology', 'development', 'business', 'startup',
    'ai', 'machinelearning', 'blockchain', 'programming', 'cloud',
    'security', 'data', 'analytics', 'mobile', 'web'
  ], Math.floor(Math.random() * 3) + 1);

  return {
    id: `post-${index + 1}`,
    type: 'post',
    content: `Exciting developments in ${subcategory?.name || category.name}! Just discovered some amazing innovations that will revolutionize how we approach ${tags[0]}. #${tags.join(' #')}`,
    attachments: Math.random() > 0.5 ? [
      {
        type: Math.random() > 0.5 ? 'image' : 'link',
        url: Math.random() > 0.5 
          ? `https://images.unsplash.com/photo-${1550000000000 + index}?w=1200`
          : `https://example.com/${category.slug}/${index}`,
        preview: 'Check out this amazing resource!'
      }
    ] : undefined,
    author,
    createdAt: new Date(Date.now() - Math.random() * 10000000000),
    updatedAt: new Date(Date.now() - Math.random() * 10000000000),
    likes: Math.floor(Math.random() * 1000),
    likedBy: [],
    views: Math.floor(Math.random() * 5000),
    tags,
    repostCount: Math.floor(Math.random() * 100),
    repostedBy: [],
    category: subcategory || category,
    region: author.region,
    language: 'en',
    visibility: 'public',
    mentions: []
  };
});

export const demoArticles: Article[] = Array(20).fill(null).map((_, index) => {
  const author = getRandomUser();
  const category = CATEGORIES[Math.floor(Math.random() * CATEGORIES.length)];
  const subcategory = category.subcategories?.[Math.floor(Math.random() * (category.subcategories?.length || 1))];
  const tags = getRandomItems([
    'innovation', 'technology', 'development', 'business', 'startup',
    'ai', 'machinelearning', 'blockchain', 'programming', 'cloud',
    'security', 'data', 'analytics', 'mobile', 'web'
  ], Math.floor(Math.random() * 4) + 2);

  const title = `The Future of ${subcategory?.name || category.name}: ${tags[0].charAt(0).toUpperCase() + tags[0].slice(1)} Innovation`;
  
  return {
    id: `article-${index + 1}`,
    type: 'article',
    title,
    content: `# ${title}\n\nExploring the latest developments in ${subcategory?.name || category.name} and their impact on the industry.`,
    excerpt: `Discover the latest trends and innovations in ${subcategory?.name || category.name} and how they're shaping the future of the industry.`,
    description: `A comprehensive analysis of ${subcategory?.name || category.name} trends and their impact on business and technology.`,
    category: subcategory?.name || category.name,
    author,
    createdAt: new Date(Date.now() - Math.random() * 10000000000),
    updatedAt: new Date(Date.now() - Math.random() * 10000000000),
    likes: Math.floor(Math.random() * 500),
    likedBy: [],
    views: Math.floor(Math.random() * 2000),
    readingTime: Math.floor(Math.random() * 10) + 5,
    tags,
    coverImage: `https://images.unsplash.com/photo-${1560000000000 + index}?w=1200`,
    region: author.region,
    language: 'en',
    visibility: 'public'
  };
});

export const demoVideos: Video[] = Array(20).fill(null).map((_, index) => {
  const author = getRandomUser();
  const category = CATEGORIES[Math.floor(Math.random() * CATEGORIES.length)];
  const subcategory = category.subcategories?.[Math.floor(Math.random() * (category.subcategories?.length || 1))];
  const tags = getRandomItems([
    'tutorial', 'guide', 'howto', 'explanation', 'review',
    'demo', 'showcase', 'walkthrough', 'tips', 'tricks'
  ], Math.floor(Math.random() * 3) + 2);

  const title = `${tags[0].charAt(0).toUpperCase() + tags[0].slice(1)}: ${subcategory?.name || category.name} Masterclass`;

  return {
    id: `video-${index + 1}`,
    type: 'video',
    title,
    description: `Learn everything you need to know about ${subcategory?.name || category.name} in this comprehensive ${tags[0]}.`,
    videoUrl: `https://example.com/videos/${category.slug}/${index}.mp4`,
    thumbnailUrl: `https://images.unsplash.com/photo-${1570000000000 + index}?w=1200`,
    duration: Math.floor(Math.random() * 1800) + 600, // 10-40 minutes
    category: subcategory?.name || category.name,
    author,
    createdAt: new Date(Date.now() - Math.random() * 10000000000),
    updatedAt: new Date(Date.now() - Math.random() * 10000000000),
    likes: Math.floor(Math.random() * 800),
    likedBy: [],
    views: Math.floor(Math.random() * 3000),
    tags,
    quality: {
      resolution: Math.random() > 0.5 ? '4K' : '1080p',
      fps: Math.random() > 0.5 ? 60 : 30
    },
    region: author.region,
    language: 'en',
    visibility: 'public'
  };
});